import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { Store } from '@ngxs/store';

@Component({
  selector: 'rk-app-update-modal',
  standalone: false,
  templateUrl: './app-update-modal.component.html',
  styleUrl: './app-update-modal.component.scss',
})
export class AppUpdateModalComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<AppUpdateModalComponent>);
  private readonly store = inject(Store);

  ngOnInit(): void {
    this.store.dispatch(
      new SetEventProperties({
        name: 'ModalAppUpdate',
        component: 'ModalAppUpdate',
      }),
    );

    this.store.dispatch(new LogEvent('Modal Viewed'));
  }

  onClose(): void {
    this.dialogRef.close(false);

    this.store.dispatch(
      new SetEventProperties({
        name: 'ButtonCancelUpdate',
        component: 'ModalAppUpdate',
      }),
    );

    this.store.dispatch(new LogEvent('Button Clicked'));
  }

  onConfirmUpdate(): void {
    this.store.dispatch(
      new SetEventProperties({
        name: 'ButtonConfirmUpdate',
        component: 'ModalAppUpdate',
      }),
    );

    this.store.dispatch(new LogEvent('Button Clicked'));

    this.dialogRef.close(true);
  }
}
